import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);



jQuery(document).ready(function ($) {
    const $qs = (css, parent = document) => parent.querySelector(css);
    const $qsa = (css, parent = document) => parent.querySelectorAll(css);

    consoleMessage: {
        console.log('%cCreated by %cTWK%cwww.thewebkitchen.co.uk', 'background: #13212E; color: #FFFFFF; padding: 5px 0px 5px 10px; margin: 25px 0px;', 'background: #13212E; color: #05E5C8; padding: 5px 10px 5px 0px; font-weight: bold;', 'background: #FFFFFF; padding: 5px 10px;');
    }
	slider: {
		$('.grid__item--slider').slick({
			dots: true
			, arrows: false
			, fade: true
			, autoplay: true
			, autoplaySpeed: 4500
			
		, });
		$('.sidebar__twitter__slider').slick({
			dots: true
			, arrows: false
			, autoplay: true
			, autoplaySpeed: 4500
			
        , });
        $('.slider').slick({
			dots: true
			, arrows: false
			, autoplay: true
			, autoplaySpeed: 4500
			
        , });
        $('.grid__item--blue--twitter').slick({
			dots: true
			, arrows: false
			, autoplay: true
			, autoplaySpeed: 4500
			
        , });

		// slider-overflow
		$('.slider-overflow').slick({
			dots: false,
			arrows: true,
			autoplay: false,
			autoplaySpeed: 4500,
			centerMode: true,
			centerPadding: '20%',
			slidesToShow: 1,
			infinite: true,
			speed: 500,
			cssEase: 'ease-out',
			prevArrow: '<div class="slick-arrow-prev"><svg xmlns="http://www.w3.org/2000/svg" width="52" height="53" fill="none"><circle cx="25.996" cy="26.33" r="26" fill="#E64097" transform="rotate(90 25.996 26.33)"/><path fill="#fff" fill-rule="evenodd" d="m29.309 21.078-1.314-1.314-5.253 5.253-1.313 1.313 6.566 6.566 1.313-1.313-5.253-5.252 5.254-5.253Z" clip-rule="evenodd"/></svg></div>',
			nextArrow: '<div class="slick-arrow-next"><svg xmlns="http://www.w3.org/2000/svg" width="52" height="53" fill="none"><circle cx="25.996" cy="26.33" r="26" fill="#E64097" transform="rotate(-90 25.996 26.33)"/><path fill="#fff" fill-rule="evenodd" d="m22.683 31.583 1.313 1.313 5.253-5.253 1.314-1.313-6.567-6.566-1.313 1.314 5.253 5.252-5.253 5.253Z" clip-rule="evenodd"/></svg></div>',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						centerPadding: '10%',
						slidesToShow: 1
					}
				}
			]
		});

		document.querySelectorAll('.slider-overflow  .slick-slide').forEach(item => {
			const content = item.querySelector('.slider-overflow__item__content');
			const title = content?.querySelector('.title');
			const text = content?.querySelector('p');
			const link = content?.querySelector('.link');
			const contentMove = content?.querySelector('.content-move');
			const contentMoveHeight = contentMove?.offsetHeight;
			const overlay = item?.querySelector('.overlay--pink');
			
			// Only animate if elements exist
			if (text || link) {
				gsap.set([text, link].filter(Boolean), { y: contentMoveHeight, opacity: 0 });
			}
			
			if (title) {
				gsap.set(title, { y: contentMoveHeight });
			}
			
			if (overlay) {
				gsap.set(overlay, { opacity: 0 });
			}
			
			// Only create timeline if necessary elements exist
			if (title || text || link || overlay) {
				const tl = gsap.timeline({ paused: true });
				
				tl
					.to(title, { y: 0, duration: 0.5, ease: "power2.out" })
					.to([text, link].filter(Boolean), { y: 0, opacity: 1, duration: 0.5, stagger: 0.1, ease: "power2.out" }, "-=0.3")
					.to(overlay, { opacity: 1, duration: 0.5 }, 0);
				
				// Add hover listeners
				item.addEventListener('mouseenter', () => tl.play());
				item.addEventListener('mouseleave', () => tl.reverse());
			}
		});
	}
	anchorlinks: {
		$(document).on('click', '.anchor', function (event) {
			event.preventDefault();
			$('html, body').animate({
				scrollTop: $($.attr(this, 'href')).offset().top
			}, 500);
		});
	}
	fixedheader: {
		$(function () {
			if (document.querySelector('.header')) {
				$(window).scroll(function () {
					if ($(window).scrollTop() >= 150) {
						$('.header').addClass('fixed-header');
					}
					if ($(window).scrollTop() >= 160) {
						$('.header').addClass("transform-none");
					}
					else {
						$('.header').removeClass('fixed-header');
						$('.header').removeClass("transform-none");
					}
				});
			}
		});
	}
	mobile: {
		///MOBILE MENU - FOR USE WITH TWK_NAV_WALKER
		//                $('.menu .menu-item-has-children > a').click(function (event) {
		//                    event.preventDefault();
		//                    $(this).parent().children('li .sub-menu-wrap').addClass('transform-none');
		//                });
		//                $('.back-menu').click(function () {
		//                    $(this).parent().parent().removeClass('transform-none');
		//                });
	}
    gridAnimation: {

        // setTimeout(function() {
        //     $('.loader-wrap').fadeOut();
        // }, 700);
        var tl = new TimelineMax({ } );
        tl.from($('.nav-bar'), 0.4, { ease: Power4.easeOut, opacity: 0 , y: -120}).staggerFrom($('.grid__item'),0.8,{ ease: Power4.easeOut, opacity: 0 , y: 260}, 0.1, "-=0.4");

    }
	magnific: {
		///IFRAME
		$('.magnific-video').magnificPopup({
			type: 'iframe'
			, mainClass: 'mfp-fade'
			, removalDelay: 160
			, preloader: false
			, fixedContentPos: false
		});
        // GALLERY IMAGE
        $('.magnific-gallery-image').magnificPopup({
            type: 'image',
            closeOnContentClick: true,
            mainClass: 'mfp-img-mobile',
            image: {
                verticalFit: true,
                titleSrc: function(item) {
                    return item.el.attr('title');
                }
            },
            gallery:{
                enabled:true
            }
        });
		// Modal
		$('.basic-popup').magnificPopup({
			type: 'inline',
	
			fixedContentPos: false,
			fixedBgPos: true,
	
			overflowY: 'auto',
	
			closeBtnInside: true,
			preloader: false,
			
			midClick: true,
			removalDelay: 300,
			mainClass: 'my-mfp-zoom-in'
		});

        $('.js-popup-basic').magnificPopup({
            type: 'inline',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: true,
            fixedBgPos: true,
            overflowY: 'hidden',
            autoFocusLast: false,
            closeMarkup: `<button title="%title%" type="button" class="mfp-close"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#F5B3D6" stroke-width="2" stroke-linecap="square" stroke-linejoin="arcs"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>`,
        });
	}
	externallinks: {
		// $('a:not(.magnific-video), a[href*="Abingdon_Prep_Prospectus"]').each(function () {
		// 	var a = new RegExp('/' + window.location.host + '/');
		// 	if (!a.test(this.href)) {
		// 		$(this).click(function (event) {
		// 			event.preventDefault();
		// 			window.open(this.href, '_blank');
		// 		});
		// 	}
		// });
		pdfs: {
			///OPEN PDFS IN NEW WINDOW
			$(function () {
				$('a[href$=".pdf"]').prop('target', '_blank');
			});
		}
	}
	search: {
		$('.search-open').on('click', function (e) {
			$('.search').addClass('search--open');
            $('.menu-top-menu-container').fadeOut();
            $('#s').focus();
        });
       
		$('#content-wrap').on('click', function (e) {
			if (!($("#s").is(":focus"))) {
                $('.search').removeClass('search--open');
                $('.menu-top-menu-container').fadeIn();
            }
		});
	}


	overviewTemplate: {
		// FACILITIES
		let tallestFacilityContent = 0;
		const facilityContents     = document.querySelectorAll('.facilities-content__item__content');
		const facilitiesContainer  = document.querySelector('.facilities-content');
		const facilityItems        = document.querySelectorAll('.facilities-content__item');
		const navItems             = document.querySelectorAll('.facilities-nav__item');
		const facilityAllImages    = document.querySelectorAll('.facilities-content__image');
		const facilityAllTexts     = document.querySelectorAll('.facilities-content__text');

		if ( facilityContents.length > 0 && window.innerWidth >= 768 ) {
			// Find tallest content
			facilityContents.forEach(content => {
				const height = content.offsetHeight;
				if (height > tallestFacilityContent) {
					tallestFacilityContent = height;
				}
			});
	
			// Set container height and position
			facilitiesContainer.style.height = `${tallestFacilityContent}px`;
			facilityItems.forEach(item => {
				item.style.position = 'absolute';
			});
	
			// Preparation
			gsap.set( facilityItems, { opacity: 0 });
			gsap.set( facilityItems[0], { opacity: 1 });
	
			facilityAllImages.forEach((image, index) => {
				if (index !== 0) { gsap.set(image, { yPercent: 100 }); }
			});
			facilityAllTexts.forEach((text, index) => {
				if (index !== 0) { gsap.set(text, { y: -40 }); }
			});
	
			// Handle nav clicks
			navItems.forEach(navItem => {
				navItem.addEventListener('click', () => {
					// Remove active class from all nav items
					navItems.forEach(item => item.classList.remove('active'));
					navItem.classList.add('active');
	
					const facility = navItem.dataset.facility;

					// Get which facility was active before
					const activeFacilityNumber = document.querySelector('.facilities-content__item.active')?.dataset.facility;
					facilityItems.forEach(item => item.classList.remove('active'));
					document.querySelector(`.facilities-content__item[data-facility="${facility}"]`)?.classList.add('active');
					
					const facilityContent = document.querySelector(`.facilities-content__item[data-facility="${facility}"]`);
					const facilityImage = facilityContent.querySelector('.facilities-content__image');
					const facilityText = facilityContent.querySelector('.facilities-content__item__content');

					const previousFacilityImages = Array.from(document.querySelectorAll('.facilities-content__image'))
												.filter(img => img.closest('.facilities-content__item').dataset.facility < facility);
					const nextFacilityImages = Array.from(document.querySelectorAll('.facilities-content__image'))
												.filter(img => img.closest('.facilities-content__item').dataset.facility > facility);
					const otherFacilityTexts = Array.from(document.querySelectorAll('.facilities-content__item__content'))
												.filter(text => text.closest('.facilities-content__item').dataset.facility !== facility);

					const timeline = gsap.timeline();
					if ( activeFacilityNumber < facility ) {
						timeline
							.to(facilityContent, { duration: 0.1, opacity: 1, ease: "none" } )
							.to( previousFacilityImages, { duration: 0.3, yPercent: 0, ease: "none" }, "<")
							.to( facilityImage, { duration: 0.3, yPercent: 0, ease: "none" }, "<")
							.to( otherFacilityTexts, { duration: 0, y: 0, opacity: 0, ease: "none" }, "<" )
							.fromTo(facilityText, { y: -40, opacity: 0 },{ duration: 0.3, y: 0, opacity: 1, ease: "none" }, "<");
					} else {
						timeline
							.to(facilityContent, { duration: 0.1, opacity: 1, ease: "none" } )
							.to(nextFacilityImages, { duration: 0.3, yPercent: 100, ease: "none" }, "<")
							.to( otherFacilityTexts, { duration: 0, y: 0, opacity: 0, ease: "none" }, "<" )
							.fromTo(facilityText, { y: 40, opacity: 0 },{ duration: 0.3, y: 0, opacity: 1, ease: "none" }, "<");
					}
				})
			});
		}





		// Map toggles
		if ( $('.map-toggle').length ) {
			$('.map-toggle').on('click', function() {
				const mapNumber = $(this).data('map');
				
				// Update toggles
				$('.map-toggle').removeClass('active');
				$(this).addClass('active');
				
				// Update map visibility
				$('.maps-iframe-container').removeClass('active');
				$(`.maps-iframe-container[data-map="${mapNumber}"]`).addClass('active');
			});
		}
	}





	loadingAnimations: {
		$.fn.isOnScreen = function () {
			var win = $(window);
			var viewport = {
				top: win.scrollTop()
			, };
			viewport.bottom = viewport.top + win.height() - 100;
			var bounds = this.offset();
			bounds.bottom = bounds.top + this.outerHeight();
			return (!(viewport.bottom < bounds.top || viewport.top > bounds.bottom));
		};
		$(window).scroll(function () {
			$('.off-screen').each(function (index) {
				if ($(this).isOnScreen()) {
					$(this).removeClass('off-screen--hide');
				}
			});
		});
	}
	onLoad: {
		$(document).ready(function () {
			$('.off-screen').each(function (index) {
				if ($(this).isOnScreen()) {
					$(this).removeClass('off-screen--hide');
				}
			});
		});
	}
	
	calendar: {
	/********************************************\
        # CALENDAR FUNCTIONS
    \********************************************/
	if($('body.page-template-tpl-calendar').length || $('body.page-id-65').length)
        {
            mainCalendar();
            calendarLightbox();
        }
    function mainCalendar()
    {
        var DDMonthEdit = true;
        // On Month Change dropdown
        $(document).on('change', ".month-dd-list", function(e){
            var month = $(this).val();
            DDMonthEdit = false;
            $('.tribe-mini-calendar-nav-link.prev-month').attr('data-month',month).trigger('click');
        });


        // On "Event next month click" trigger
        $('.trigger-week,.trigger-next, .trigger-current').click(function(e){

            var d     = new Date();

            // Add 1 month to current date if click on "display next month"
            $(this).hasClass('trigger-next') ? d.setMonth(d.getMonth() + 1): '';

            var yr    = d.getFullYear();
            var month = d.getMonth()+1;
                month = month < 10 ? '0' + month : month;
            var newD  = yr + '-' + month + '-01';

            // Add Class to triggered btn if it's week-view (will let us change the query to show 7 days only)
            $(this).hasClass('trigger-week') ? $('.tribe-mini-calendar-nav-link.next-month').addClass('week-view') : '';

            $('.tribe-mini-calendar-nav-link.next-month').attr('data-month',newD).trigger('click');

            $('.calendar-nav .active-item').removeClass('active-item');
            $(this).addClass('active-item');

            e.preventDefault();
        })


        //This load event for a month or a day
        $(document).on("click",".tribe-mini-calendar-nav a, .tribe-mini-calendar-day-link", function(e){

            $('.calendar-nav .active-item').removeClass('active-item');
            if($(this).is("[data-month]"))
                var type = "month";
            else
            {
                var type = "day";
                $('.tribe-events-present').removeClass('tribe-events-present'); // Remove background color of today date when click an another day
            }


            //------------------------------------------------------------------------------------
            // If sports filters has a specific category (other than all)…
            // if($('.subcat-events-filters').val() != 'all')
            // {
            //     var subCat = $('.subcat-events-filters').val() // get that cat
            //     var divCat = $('.events-filters').val(); // get main cat
            //     var cat = { 
            //         "cat1" : subCat,
            //         "cat2" : divCat,
            //     };
            // }
            // else // otherwise…
                var cat = $('.events-filters').val(); // get main cat
            //------------------------------------------------------------------------------------
            //var cat = $('option[data-selected=true]').val();
            
            var start_date = $(this).attr('data-'+type);

            // Check if user requested week view
            var week = false;
            if($(this).hasClass('week-view'))
            {
                week = true; 
                $(this).removeClass('week-view');
            }

            // Change month Dropdown selection
            // if(type == "month" && DDMonthEdit)
            if($(this).hasClass('tribe-mini-calendar-nav-link') && DDMonthEdit)
            { 
                $('.month-dd-list option').removeAttr('selected');
                $('.month-dd-list option[value="'+start_date+'"]').attr('selected','selected');
            }

            loadEvents(start_date, type, cat, week);

            DDMonthEdit = true;
            e.preventDefault(); 
        });


        // This filter events
        $(document).on("change",".events-filters",function(e){
			if (!$('.events-filters').length) return; // Exit if element doesn't exist

            $('.events-filters option').removeAttr('data-selected');
            $('option:selected',this).attr('data-selected',true);

            var type = $('.ajax-events').attr('data-type');
            var start_date = $('.ajax-events').attr('data-date');
            var cat = $(this).val();

            //------------------------------------------------------------------------------------
            // NEW: SHOW SUBCAT FILTERS IF…
            var subcat_filter_wrapper = $('.subcat-filter-wrapper');

            // Delete subcat filters when change main filter
            if(subcat_filter_wrapper.length) { subcat_filter_wrapper.remove(); }

            if($('option:selected',this).attr('data-children') === 'true') // If main has subcat
            {
                var termid = $('option:selected',this).attr('data-termid');

                // Populate subcat filters…
                $.ajax({
                    url: location.origin+'/wp-admin/admin-ajax.php',
                    data:{
                        'action':'termchildren_ajax',
                        'termid':termid,
                    },
                    type: "GET",
                    dataType: 'JSON',
                    success:function(data){
                        // $('.allfilters').prepend(data);
                        $('.allfilters').append(data);
                    },
                    error: function(errorThrown){
                        console.log(errorThrown);
                    }
                });
            }

            // Reset sport filters to default everytime user change main cat
            $('.subcat-events-filters').prop('selectedIndex',0); 
            //------------------------------------------------------------------------------------

            loadEvents(start_date, type, cat);
        });


        // This is sport filter 
        $(document).on("change",".subcat-events-filters",function(e){
            $('.subcat-events-filters option').removeAttr('data-selected');
            $('option:selected',this).attr('data-selected',true);

            var type = $('.ajax-events').attr('data-type');
            var start_date = $('.ajax-events').attr('data-date');


            //------------------------------------------------------------------------------------
            // NEW: IF USER SELECT A SUBCAT 
            if($(this).val() != 'all') // If subcat filter has a category (other than all)
            {
                var divCat = $('.events-filters').val();
                var cat = { 
                    "cat1" : $(this).val(), 
                    "cat2" : divCat,
                };
            }
            else // If user switch back to all then show events from the main cat
                var cat = $('.events-filters').val();
            //------------------------------------------------------------------------------------

            loadEvents(start_date, type, cat);
        });
    }

    function loadEvents(start_date, type, cat, week)
    {
        cat = cat || "all"; // Set to all if no cat specified
        week = week || false; // Set to false if not specified
        var blogid = $('.calendar-nav').attr('siteid');
        console.log(blogid);
        var calendar = $('.ob-calendar').length ? 'ob-calendar' : 'main-calendar';

        $('.ajax-events').html('<img src="'+php_vars.themeDirUrl+'/assets/img/loader.gif" width="200px" height="200px" style="display: block; margin: 0 auto;" />')

        $.ajax({
            url: location.origin+'/senior/wp-admin/admin-ajax.php',
            data:{
                'action':'events_ajax',
                'start_date':start_date,
                'ndate':start_date,
                'type':type,
                'cat':cat,
                'week':week,
                'calendar':calendar,
                'blogid':blogid,
            },
            type: "GET",
            dataType: 'JSON',
            success:function(data){
                $('.ajax-events').html(data.content).attr({
                    // Set data-type and data-date to grab the date for filter
                    'data-type':data.type,
                    'data-date':data.ndate, 
                });

                // Change export month button
                // Convert yyyy-mm-dd hh:ii:ss to yyyy/mm/dd to make it cross browsers (not working in IE & Safari)
                var date = data.ndate;
                var date = date.split(" ");
                var date = date[0];
                var date = date.replace(/\-/g,'/');

                var date    = new Date(date);
                var yr      = date.getFullYear();
                var month   = parseInt(date.getMonth()+1);
                    month   = month < 10 ? '0' + month : month;
                var newDate = yr + '-' + month;

                // if(data.cat)
                //     $('.export-month').attr('href','/events/'+newDate+'?ical=1&tribe_year='+yr+'&tribe_month='+month+'&tribe_cat='+data.cat);
                // else
                //     $('.export-month').attr('href','/events/'+newDate+'?ical=1&tribe_year='+yr+'&tribe_month='+month);

                //console.log(data.cat);

                if(data.cat)
                {
                    if(jQuery.isPlainObject(data.cat))
                        $('.export-month.filtered').attr('href','/events/?ical=1&filtered=1&tribe_cat[]='+data.cat.cat1+'&tribe_cat[]='+data.cat.cat2);
                    else
                        $('.export-month.filtered').attr('href','/events/?ical=1&filtered=1&tribe_cat='+data.cat);
                }
            },
            error: function(errorThrown){
                console.log(errorThrown);
            }
        });
    }

    function calendarLightbox()
    {
        $(document).on('click touchstart','.ajax-events.caltpl .event a', function(e){

            var item = $(
                '<div class="custom-lightbox">'+
                    '<div class="custom-lightbox__container box-shadow entry flex" style="height:auto">'+
                        '<i class="fonticon custom-lightbox__close">✕</i>'+
                        '<div class="custom-lighbox__content is_calendar flex">'+
                            '<div id="content-area">'+
                                '<img src="'+php_vars.themeDirUrl+'/assets/img/loader.gif" class="loadergif" />'+
                            '</div>'+
                        '</div>'+
                    '</div>'+
                    '<div class="custom-lightbox__background"></div>'+
                '</div>'
            ).hide();

            $('body').prepend(item);
            item.fadeIn(200);

            var $item = $(this);
            var url = $item.attr('href');

            // $('#calendar-lightbox .calendar-lightbox__content').load(url+" #ajax-cal-content");
            $('#content-area').load(url+" #ajax-cal-content");

            e.preventDefault();
        });

        
        // Close when click the cross
        $(document).on('click touchstart', '.custom-lightbox__close', function(){ closeCalendarLightbox(); });

        // Close when click outside the lightbox
        $(document).on('click touchstart','.custom-lightbox',function(){ closeCalendarLightbox(); });
        $(document).on('click touchstart','.custom-lightbox__container',function(event){ event.stopPropagation(); });

        // Close when click ESC
        $(document).keyup(function(e) { if (e.keyCode == 27) closeCalendarLightbox(); });
    }

    function closeCalendarLightbox()
    {
        $('.custom-lightbox').fadeOut(200,function(){
            $('.calendar-lightbow__content').fadeOut(200,function(){
                $('.custom-lightbox, .calendar-lightbox__content').remove();
            });
        });
    }
    }


	calendarPlugin:{
		let calendarLinks = document.querySelectorAll('.tribe-events-calendar-month__calendar-event-title-link, .tribe-events-calendar-month__multiday-event-hidden-link, .tribe-events-calendar-list__event-title-link, .tribe-events-pro-week-grid__event-link');

		if ( calendarLinks.length > 0 ) {
			calendarLinks.forEach(function(link) {
				link.onclick = function(e) {
					e.preventDefault();
				}
			});
		}
	}




        menu: {
            const pageWrap = document.querySelector('#content-wrap');
            const burger = document.querySelector('.nav-menu__hamburger');
            const burgerInner = document.querySelector('.hamburger__inner');
            const menu = document.querySelector('.nav-bar__menu');
            const closeMenu = document.querySelector('.header__menu__main__close');
            //const menuAnimate = document.querySelector('.header__menu__main .off-screen');
            const menuItems = $('#menu-nested-pages > li:has(div ul) > a');
            const subMenus = document.querySelectorAll('.sub-menu-wrap');
    
            //animate burger
            function toggleOpen(element) {
                element.classList.toggle('open');
                setTimeout(function() {
                    element.classList.toggle('visible');
                }, 200);
                //element.classList.toggle('off-screen--static');
            } 
    
            function dullBackground(element) {
                element.classList.toggle('menu-open');
                //element.classList.toggle('off-screen--static');
            }
    
            //animate burger and menu on click on hamburger
            burger.onclick = function(){
                toggleOpen(burgerInner);
                //toggleOpen(menuAnimate);
                toggleOpen(menu);
                dullBackground(pageWrap);
            };
    
            pageWrap.onclick = function(){
                // if(hasClass(pageWrap, 'menu-open')) {
                // 	toggleOpen(burger);
                // 	//toggleOpen(menuAnimate);
                // 	toggleOpen(menu);
                // 	dullBackground(pageWrap);
                // }
            };
            
    
            // closeMenu.onclick = function(){
            //     toggleOpen(burgerInner);
            //     //toggleOpen(menuAnimate);
            //     toggleOpen(menu);
            //     dullBackground(pageWrap);
            //     menuItems.forEach(function(menuItem) {
            //         menuItem.classList.remove('active');
            //     });
            //     // subMenus.forEach(function(subMenu) {
            //     //     subMenu.classList.remove('open');
            //     // });
            // }; 

        
            // menuItems.forEach(function(item) {
                
            //     item.children[0].onclick = function(e){
            //         e.preventDefault();
            //         let submenu = item.childNodes;
            //         if(submenu[2]) {
                      
            //             menuItems.forEach(function(menuItem) {
            //                 menuItem.classList.remove('active'); 
        
            //             });
            //             item.classList.add('active');
            //             subMenus.forEach(function(subMenu) {
            //                 subMenu.classList.remove('open');
            //                 //subMenu.classList.add('off-screen--static');
            //             });
            //             toggleOpen(submenu[2]); 
            //         }    
            //         return false; 
            //     };
            // }); 

   
            $(menuItems).on(' click', function(e) {
                var self = this;
                e.preventDefault();
                menu.classList.add('menu-clicked');



                $('.menu-item').removeClass('active');
                $(subMenus).removeClass('open');
                $('.sub-menu').removeClass('animate-items');

                $(this).closest('li').addClass('active');
                
                $(this).parent('li').children('.sub-menu-wrap').addClass('open');

           

            });
            
            
            $('#content-wrap').on('click', function() {
                burgerInner.classList.remove('open');
                menu.classList.remove('open-menu'); 
                pageWrap.classList.remove('menu-open'); 
                subMenus.forEach(function(subMenu) {
                    subMenu.classList.remove('open');
                });
            });
              
            $('.back-button').on('click', function() {
                console.log('clicked');
                subMenus.forEach(function(subMenu) {
                    subMenu.classList.remove('visible');
                    subMenu.classList.remove('open');
                });
            });
        }
        img: {
        
            let imgContainers;
            let len;
            
            if (!Modernizr.objectfit) {
                imgContainers = document.querySelectorAll('.image-wrap');
                len = imgContainers.length;
            
                for (var i=0; i<len; i++) {
                    const container = imgContainers[i],
                        imgUrl = container.querySelector('img').getAttribute('src');
    
                    if (imgUrl) {
                        container.style.backgroundImage = 'url(' + imgUrl + ')';
                        $(container).addClass('image-wrap--ie');  
                    }
                }
            }
        }
        toggleReadMore: {
        
            $('.read-more__toggle').on('click', function() {
                let text = $(this).text();
                $(this).prev('.read-more').slideToggle();
                $(this).text(
                    text == "READ MORE" ? "READ LESS" : "READ MORE"
                );
            });
        }
    
        accordion: {
            function toggleAccordion() {
            
                $('.js-accordion-target').not($(this).next('.js-accordion-target')).slideUp();
                $('.js-accordion-plus').not($(this).find('.js-accordion-plus')).removeClass('active');
                $(this).next('.js-accordion-target').slideToggle();
                $(this).find('.js-accordion-plus').toggleClass('active');
            }
            
            const accordions = document.querySelectorAll(".js-accordion-trigger");
            accordions.forEach(function(accordion) {
                accordion.addEventListener("click", toggleAccordion, false);
            });
        }


        sidebartoggle: {
            $('.sidebar .menu .page_item_has_children > a').on('click', function() {
                $(this).find('.children').slideToggle();
            });
        }
        
        modal: {
            
        }
        counters: {
            $(window).scroll(function () {
                $('.count').each(function () {
                    if ($(this).isOnScreen()) {
                        $(this).prop('Counter',0).animate({
                            Counter: $(this).attr('number')
                        }, {
                            duration: 2000,
                            easing: 'swing',
                            step: function (now) {
                                $(this).text(Math.ceil(now));
                            }
                        });
                    }
                });
            });
        }
        tables: {
            $('body:not(.page-template-tpl-calendar) table:not(.mptt-shortcode-table)').wrap('<div class="tables-responsive"></div>');
            $('.mptt-menu').wrap('<div class="select-wrapper"></div>');
        }
        cookies: {
            (function(factory){var registeredInModuleLoader=!1;if(typeof define==='function'&&define.amd){define(factory);registeredInModuleLoader=!0}
            if(typeof exports==='object'){module.exports=factory();registeredInModuleLoader=!0}
            if(!registeredInModuleLoader){var OldCookies=window.Cookies;var api=window.Cookies=factory();api.noConflict=function(){window.Cookies=OldCookies;return api}}}(function(){function extend(){var i=0;var result={};for(;i<arguments.length;i++){var attributes=arguments[i];for(var key in attributes){result[key]=attributes[key]}}
            return result}
            function init(converter){function api(key,value,attributes){var result;if(typeof document==='undefined'){return}
            if(arguments.length>1){attributes=extend({path:'/'},api.defaults,attributes);if(typeof attributes.expires==='number'){var expires=new Date();expires.setMilliseconds(expires.getMilliseconds()+attributes.expires*864e+5);attributes.expires=expires}
            attributes.expires=attributes.expires?attributes.expires.toUTCString():'';try{result=JSON.stringify(value);if(/^[\{\[]/.test(result)){value=result}}catch(e){}
            if(!converter.write){value=encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent)}else{value=converter.write(value,key)}
            key=encodeURIComponent(String(key));key=key.replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent);key=key.replace(/[\(\)]/g,escape);var stringifiedAttributes='';for(var attributeName in attributes){if(!attributes[attributeName]){continue}
            stringifiedAttributes+='; '+attributeName;if(attributes[attributeName]===!0){continue}
            stringifiedAttributes+='='+attributes[attributeName]}
            return(document.cookie=key+'='+value+stringifiedAttributes)}
            if(!key){result={}}
            var cookies=document.cookie?document.cookie.split('; '):[];var rdecode=/(%[0-9A-Z]{2})+/g;var i=0;for(;i<cookies.length;i++){var parts=cookies[i].split('=');var cookie=parts.slice(1).join('=');if(!this.json&&cookie.charAt(0)==='"'){cookie=cookie.slice(1,-1)}
            try{var name=parts[0].replace(rdecode,decodeURIComponent);cookie=converter.read?converter.read(cookie,name):converter(cookie,name)||cookie.replace(rdecode,decodeURIComponent);if(this.json){try{cookie=JSON.parse(cookie)}catch(e){}}
            if(key===name){result=cookie;break}
            if(!key){result[name]=cookie}}catch(e){}}
            return result}
            api.set=api;api.get=function(key){return api.call(api,key)};api.getJSON=function(){return api.apply({json:!0},[].slice.call(arguments))};api.defaults={};api.remove=function(key,attributes){api(key,'',extend(attributes,{expires:-1}))};api.withConverter=init;return api}
            return init(function(){})}));
            $(document).on('click', '.modal-overlay--notice .modal-item__close', function (event) {
                Cookies.set('seen-banner', 'yes', {
                    expires: 1
                    , path: '/' 
                });
                $('.modal-overlay--notice').fadeOut();
            });
            setTimeout(function () {
                $('.modal-overlay--notice').fadeIn();
            }, 2000);
        }
        password: {
          
        }
        filtermobile: {
            $('.searchandfilter h4').on('click', function (event) {
                $('.searchandfilter > ul > li ul').removeClass('open');
                $(this).next('ul').s('open');
                $(this).toggleClass('toggled');
               
            });
        }
        maps: {

        } 
        iframe: {
            $('article iframe[allowfullscreen]').addClass('responsive-iframe');
            $('article iframe[allowfullscreen]').wrap('<div class="video-container"></div>');
        }
    
        function resetAllTabs(thisTabsContainer, tabs) {
    
            let allTabs = $qsa(`.js-tab-control[data-tabs="${tabs}"], .js-tab-content[data-tabs="${tabs}"]`, thisTabsContainer);
            
            [...allTabs].forEach(tab => tab.classList.remove('active'));
            
        }
        
        function toggleTabs(clickedTab, thisTabsContainer, tabs) {
            
            let clickedTabIndex = clickedTab.dataset.tab;
            let clickedTabContent = $qs(`.js-tab-content[data-tab="${clickedTabIndex}"][data-tabs="${tabs}"]`, thisTabsContainer);
            
            resetAllTabs(thisTabsContainer, tabs);
            
            clickedTab.classList.add('active');
            clickedTabContent.classList.add('active');
        }
        
        function toggleMobileTabs(_this, thisTabsContainer) {
            
            let selectedTabIndex = _this.value;
            let selectedTabContent = $qs(`.js-tab-content[data-tab="${selectedTabIndex}"]`, thisTabsContainer);
            
            resetAllTabs(thisTabsContainer);
            
            selectedTabContent.classList.add('active');
        }
        
        function Tabs() {
            
            let tabsContainers = $qsa('.js-tabs');
                
            tabsContainers && [...tabsContainers].forEach(tabsContainer => {
                const { tabs } = tabsContainer.dataset;
                let tabControls = $qsa(`.js-tab-control[data-tabs="${tabs}"]`, tabsContainer);
                let tabContents = $qsa(`.js-tab-content[data-tabs="${tabs}"]`, tabsContainer);
                let tabsContentContainer = $qs(`.tabs__container[data-tabs="${tabs}"]`, tabsContainer);
        
                tabsContainer && [...tabControls].forEach(tabControl => tabControl.addEventListener('click', () => toggleTabs(tabControl, tabsContainer, tabs), false));
        
                // set tab container height to tallest .tab__content
                let tallestHeight = 0;
                tabContents && [...tabContents].forEach(tabContent => {
                    let height = tabContent.offsetHeight;
                    if (height > tallestHeight) tallestHeight = height;
                });
        
                tabsContentContainer.style.minHeight = `${tallestHeight}px`;
                
                // Mobile select
                // let mobileTabControl = $qs('.js-tab-control--select', tabsContainer);
                // tabsContainer && mobileTabControl && mobileTabControl.addEventListener('change', function() {
                //     toggleMobileTabs(this, tabsContainer);
                // }, false);
                
            });
        }

        Tabs();


        function updateCustomCursorPosition(e, customCursor, parentClass) {
    
            const { pageX, pageY, target } = e;
            
            if (target.matches(parentClass) || target.closest(parentClass)) {
                gsap.to(customCursor, {
                    x: pageX,
                    y: pageY,
                    duration: 0.3
                });
            }
            
            updateCustomCursorStyle(e, customCursor, parentClass);
        }
        
        function updateCustomCursorStyle(e, customCursor, parentClass) {
            
            // add custom styles to the cursor based on the target of the mouse during the mouseover event
            
            const { target } = e;
            const { classList } = customCursor;
            const body = $qs('body');
        
            if (target.matches(parentClass) || target.closest(parentClass)) {
                classList.add('visible');
                body.style.cursor = 'none';
            } else {
                classList.remove('visible');
                body.style.cursor = 'auto';
            }
            
        }
        
        function Cursor(cursor, parentClass) {
            
            // - cursor element hidden on all pages
            // - add hover event listener to all elements that should show mouse when hovered over
            // - if hovering over an element, display cursor element
        
            if (!cursor || window.matchMedia('(max-width: 1200px)').matches) return;
            
            document.addEventListener('mousemove', function(e) {
                updateCustomCursorPosition(e, cursor, parentClass);
            }, false);
            
            document.addEventListener('wheel', function(e) {
                updateCustomCursorPosition(e, cursor, parentClass);
            }, false);
        
            // document.addEventListener('dragover', function(e) {
            //     updateCustomCursorPosition(e, cursor, parentClass);
            // }, false);
        }

        Cursor(document.querySelector('.custom-cursor:not(.custom-cursor--video)'), '.js-custom-cursor');
        Cursor(document.querySelector('.custom-cursor--video'), '.js-custom-cursor-video');

        function animateCircles() {
            const circles = $qsa('.js-circle-animate');

            circles && [...circles].forEach(circle => {
                gsap.from(circle, {
                    scrollTrigger: {
                        trigger: circle,
                        start: '150px bottom'
                        // markers: true
                    },
                    opacity: 0,
                    y: '50px',
                    ease: 'power2.out'
                })
            })
        }

        animateCircles();



        // floorplan popups
        function handleRoomClick() {
            console.log(this);

            const tabsSection = this.closest('section');
            const activeHouse = $qs('.js-tab-control.active[data-tabs="houses"]');
            const activeHouseName = $qs('p', activeHouse).dataset.houseName;
            const houseName = $qs('p', activeHouse).innerHTML;
            const activeFloor = $qs(`.js-tab-control.active[data-tabs="floors"][data-house-name="${activeHouseName}"]`);
            const floorName = $qs('p', activeFloor).innerHTML;
            const text = [...$qsa('text', this)].map(text => text.innerHTML);
            const roomName = text.join(' ');
            let roomType = 0;

            if($qs('polygon, polyline, path', this).style.fill === 'rgb(175, 213, 130)') {
                roomType = 'green';
            }
            else if($qs('polygon, polyline, path', this).style.fill === 'rgb(106, 176, 200)') {
                roomType = 'blue'; 
            }
            else if($qs('polygon, polyline, path', this).style.fill === 'rgb(241, 198, 103)') {
                roomType = 'orange';
            }
            else {  
                roomType = 'purple';
            }

            console.log($qs('polygon, polyline, path', this).style.fill);

           // const roomType = $qs('polygon, polyline, path', this).style.fill === 'rgb(175, 213, 130)' ? 'green' : 'blue';
            const greenBuildingContent = $qs('.green-building-content', tabsSection);
            const blueBuildingContent = $qs('.blue-building-content', tabsSection);
            const purpleBuildingContent = $qs('.purple-building-content', tabsSection);
            const orangeBuildingContent = $qs('.orange-building-content', tabsSection);
            
            let popupText = 0;

            console.log(blueBuildingContent);
 
            if(roomType === 'green') {
              popupText = ` 
                <div>
                <h4>Cost to sponsor this room: <span class="pink-color">£10,000 (£8,000 + Gift Aid)</span></h4>
                <p>(Single payment of £10,000 or £2,500 per year for 4 years; or single payment of £8,000 or £2,000 per year for 4 years + Gift Aid)</p>
           
                    ${greenBuildingContent.innerHTML}
                </div>
                <div>
                    <a class="button" href="https://www.abingdon.org.uk/about/building-the-future/pledge-room/?house=${houseName}&floor=${floorName}&room=${roomName}&roomid=${this.id}">Find Out More and Pledge</a>
                </div>
                ` 
            }
            else if(roomType === 'blue') {
                popupText = `${blueBuildingContent.innerHTML}`;
            }
            else if(roomType === 'orange') {
                popupText = `${orangeBuildingContent.innerHTML}`;
            }
            else if(roomType === 'purple') {
                popupText = `${purpleBuildingContent.innerHTML}`;
            }

            // create popup
            $.magnificPopup.open({
                items: {
                    src: `
                        <div class="popup popup--room">
                            <div class="popup__container">
                                <div class="popup__content">
                                    <h2>${houseName}</h2>
                                    <p>${floorName} <span>></span> ${roomName}</p>
                                    ${popupText}
                                </div>
                            </div>
                        </div>
                    `,
                },
                type: 'inline',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: true,
                fixedBgPos: true,
                overflowY: 'hidden',
                autoFocusLast: false,
                closeMarkup: `<button title="%title%" type="button" class="mfp-close"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#F5B3D6" stroke-width="2" stroke-linecap="square" stroke-linejoin="arcs"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>`,
            });
        }

        function setRoomStates() {
            const reservedList = $qs('.js-reserved-list');
            if(!reservedList) return;
            const reservedElements = $qsa('div', reservedList);

            reservedElements && [...reservedElements].forEach(reservedElement => {
                const roomId = reservedElement.innerText;
                const room = $qs(`.tabs--floorplans svg g#${roomId}`);
                const background = $qs('polygon, polyline, path', room);

                if (room) {
                    background.style.fill = '#a9a9a9';
                    room.style.pointerEvents = 'none';
                }
            });
        }

        function setupPopups() {

            const svgs = $qsa('.tabs--floorplans svg');

            svgs && [...svgs].forEach(svg => {
                const rooms = $qsa('g:not(#Other_Rooms):not(#Floorplan):not(g g)', svg);
                
                [...rooms].forEach(room => room.addEventListener('click', handleRoomClick));
            });

            setRoomStates();
        }

        setupPopups();
});    
